import React, { useState } from 'react';
import DoughnutChart from './Chart/DoughnutChart';
import TrendLines from './TrendLines/TrendLines.js';
import { CardWrapper, ChartCardShadow, LineCardShadow, ResourceDistributionCard, ChartTitle, StyledButton, StyledRiskScoreContainer } from './OverallRiskStyle';
import CircularProgress from '@material-ui/core/CircularProgress';
import styled from 'styled-components';
import ResourceDistribution from '../ViewDetailsPage/ResourceDistribution';
import { ButtonGroup } from '@material-ui/core';
import { setTrendData } from '../../slices/trendLinesSlice';
import { setAppTrendData } from '../../slices/ApplicationWiseTrendSlice';
import { setEnvTrendData } from '../../slices/EnvironmentwiseTrendSlice';
import { setEntityTrendData } from '../../slices/entityTrendLineSlice';
import { useDispatch, useSelector } from 'react-redux';
const CardOfOverAllRisk = styled.div`
  display: ${props => props.overallTrendLoading ? 'block' : 'flex'};
  align-items: ${props => props.overallTrendLoading ? 'none' : 'center'};
  justify-content: ${props => props.overallTrendLoading ? 'none' : 'center'};
  font-family: sans-serif;
  text-align: center;
  margin: 20px 10px;
`;

const OverallRisk = ({
  doughnutData,
  trendLineData,
  overralLineData,
  riskLabel,
  overallTrendLoading,
  handleOverallTrendLoading,
  ResourceDistributionData,
  recommendationTab
}) => {
  const buttonNameArray = ['All', '1Y', '6M', '1M', '1W'];
  const selectedTrend = useSelector(state => state.trendLines.trend);
  const [buttonValue, setbuttonValue] = useState(selectedTrend ? selectedTrend : '1M');
  const dispatch = useDispatch();

  const handleClick = event => {
    let value = event.currentTarget.value;
    setbuttonValue(value);
    dispatch(setTrendData(value));
    dispatch(setAppTrendData(value));
    dispatch(setEnvTrendData(value));
    dispatch(setEntityTrendData(value));
  };

  const riskApiResponseData = useSelector(state => state.recommendationTable.riskResponse);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CardWrapper, {
    className: "charts",
    recommendationTab: recommendationTab
  }, /*#__PURE__*/React.createElement(StyledRiskScoreContainer, {
    recommendationTab: recommendationTab
  }, /*#__PURE__*/React.createElement(ChartCardShadow, {
    ResourceDistributionData: ResourceDistributionData,
    recommendationTab: recommendationTab
  }, /*#__PURE__*/React.createElement(ChartTitle, null, riskLabel), /*#__PURE__*/React.createElement(CardOfOverAllRisk, null, /*#__PURE__*/React.createElement(DoughnutChart, {
    doughnutData: doughnutData,
    isRiskApiLoading: riskApiResponseData?.isLoading
  }))), ResourceDistributionData && /*#__PURE__*/React.createElement(ResourceDistributionCard, {
    recommendationTab: recommendationTab
  }, /*#__PURE__*/React.createElement(ChartTitle, null, 'Risk Score Details'), /*#__PURE__*/React.createElement(ResourceDistribution, {
    ResourceDistributionData: ResourceDistributionData
  }))), /*#__PURE__*/React.createElement(LineCardShadow, {
    ResourceDistributionData: ResourceDistributionData,
    recommendationTab: recommendationTab
  }, /*#__PURE__*/React.createElement(ChartTitle, null, "Risk Over Time", /*#__PURE__*/React.createElement(ButtonGroup, {
    style: {
      float: 'right'
    }
  }, buttonNameArray.map((button, index) => {
    return /*#__PURE__*/React.createElement(StyledButton, {
      key: index,
      name: button,
      value: button,
      variant: "light",
      onClick: handleClick,
      isSelected: buttonValue === button
    }, button);
  }))), /*#__PURE__*/React.createElement(CardOfOverAllRisk, {
    overallTrendLoading: overallTrendLoading
  }, overallTrendLoading ? /*#__PURE__*/React.createElement(TrendLines, {
    trendLineData: trendLineData,
    overralLineData: overralLineData,
    overallTrendLoading: overallTrendLoading,
    handleOverallTrendLoading: handleOverallTrendLoading,
    buttonValue: buttonValue
  }) : /*#__PURE__*/React.createElement(CircularProgress, null)))));
};

export default OverallRisk;